// @flow

import styled from "styled-components";
import MessageBox from "../../_molecule/MessageBox";
import { buildText } from "../../_atom/Text";

import buildColor from "../../_static/ColorPalette";

export const Description = styled(
  buildText({
    tag: "p",
    color: buildColor("grey", "800"),
    fontSize: 14,
    qaLabel: "race-description"
  })
)`
  line-height: 1.33;
  margin-top: ${(props) => (props.hasInfo ? "8px" : 0)};
`;

export const RaceInfoContainer = styled.div`
  padding: 16px 8px;
`;

export const Empty = styled(MessageBox)`
  margin-top: 16px;
  border-radius: 2px;
`;
